import React from 'react'
import { BaseInfo, BaseIconAvatar, BaseAvatar } from '../BaseRow'
import { BaseUserPermissionRow } from './UserPermissionRow.styles'

interface UserPermissionsRowProps {
  name: string
  actions: React.ReactNode
  avatarSrc?: string | null
  icon?: React.FunctionComponent
}

export const UserPermissionRow = ({
  avatarSrc,
  name,
  actions,
  icon: Icon,
}: UserPermissionsRowProps) => {
  let avatar

  if (avatarSrc) {
    avatar = <BaseAvatar src={avatarSrc} name={name} square={true} />
  } else if (Icon) {
    avatar = (
      <BaseIconAvatar mr={3}>
        <Icon />
      </BaseIconAvatar>
    )
  }

  return (
    <BaseUserPermissionRow
      name={name}
      avatar={avatar}
      actions={actions}
      showStripes={true}
    >
      <BaseInfo title={name} />
    </BaseUserPermissionRow>
  )
}
